import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel, CartLineModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

const getQuoteDetailsUrl = "/api/v1/orders";
const projectQuoteUrl = "/api/v2/orders/ProjectQuote";

export interface GetQuoteDetailsApiParameter extends ApiParameter {
    orderNumber: string;
    expand?: ("orderLines" | "shipments")[];
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
    customerSuffix?: any; // added this variable ---P21 Change
}

export interface ProjectQuoteApiParameter extends ApiParameter {
    isProject: boolean;
    hasOrderNumber: boolean;
    cartId: string;
    name: string;
    orderNumber: string;
    quoteNumber: string;
    orderTotal: number;
    orderLines: CartLineModel[] | null;
    contractUid: string; // added this variable ---P21 Change
    isQuoteCompleted: string;
    quoteLinecollection: string;  
}

export interface ProjectQuoteModel extends BaseModel {
    projectQuoteData: any;
}

export async function getQuoteDetails(
    parameter: GetQuoteDetailsApiParameter,
    customerSuffix: string | null,
): Promise<OrderModel> {
    const { orderNumber, ...newParameter } = parameter;
    const data = localStorage.getItem("quoteSuffixes");
    const modifiedOrderNumber = orderNumber + `_quotes_${data}`;
    const order = await get<OrderModel>(`${getQuoteDetailsUrl}/${modifiedOrderNumber}`, newParameter);
    return order;
}

export async function updateProjectQuote(
    parameter: ProjectQuoteApiParameter,
): Promise<ServiceResult<ProjectQuoteModel>> {
    try {
        const pickupNotification = await post<ProjectQuoteModel>(`${projectQuoteUrl}`, parameter as any);
        return {
            result: pickupNotification,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}